import { create } from 'zustand';

export const useEdiFileProcessStore = create((set) => ({
  ediFileProcessData: [],
  totalElements: 0,
  loading: false,
  error: null,

  setEdiFileProcessData: (data) => set({ ediFileProcessData: data }),
  setTotalElements: (total) => set({ totalElements: total }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),

  resetEdiFileProcessData: () => set({
    ediFileProcessData: [],
    totalElements: 0,
    loading: false,
    error: null,
  }),
}));
